import ArmsRum from "@arms/rum-browser";
const env = import.meta.env.VITE_BUILD_ENV;
const isGrayEnv = import.meta.env.VITE_IS_GRAY_ENV;
const envs: Record<string, "local" | "daily" | "prod" | "pre"> = {
  local: "local",
  dev: "daily",
  sit: "pre",
  prod: "prod",
};
ArmsRum.init({
  pid: "cd44lwy8vy@662eae6e9d696cc",
  endpoint: "https://cd44lwy8vy-default-cn.rum.aliyuncs.com",
  env: isGrayEnv ? "gray" : envs[env],
  tracing: true,
  evaluateApi: async (request, response, error) => {
    const data = {
      success: error ? 0 : 1,
      message: error ? JSON.stringify(error) : "success",
      snapshots: JSON.stringify({ request, response }),
      properties: {
        traceId: "",
        request: JSON.stringify(request),
        response: response,
        error: JSON.stringify(error),
      },
    };
    try {
      if (!error && request.url.includes(import.meta.env.VITE_HTTP_API)) {
        const responseJson =
          typeof response === "object" ? response : JSON.parse(response);
        data.snapshots = JSON.stringify({ request, response: responseJson });
        data.success = responseJson.status === "success" ? 1 : 0;
        data.message = data.success === 1 ? "success" : "error";
        data.properties.error = data.success === 1 ? "" : responseJson.msg;
        data.properties.traceId = responseJson.request_id;
      }
      return data;
    } catch (_) {
      return data;
    }
  },
});

export default ArmsRum;
